interface NotebookLoaderProps {
  status?: string;
}

export function NotebookLoader({ status }: NotebookLoaderProps) {
  // Simple status messages
  const getMessage = () => {
    switch (status) {
      case 'terminated':
        return 'Reconnecting to the Notebook';
      case 'provisioning':
        return 'Setting up the Workspace';
      case 'running':
        return 'Starting the Notebook';
      default:
        return 'Preparing the Notebook';
    }
  };

  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="text-center">
        <div className="mb-4">
          <span className="loading loading-ring loading-lg"></span>
        </div>
        <h2 className="text-lg font-semibold text-base-content">
          {getMessage()}
        </h2>
      </div>
    </div>
  );
}
